import Header from './header/header.component';
import Loader from './loader/loader.component';

angular
  .module('app.layout', [])
  .component('loader', Loader)
  .component('appHeader', Header)